import React from "react";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import Navbar from "../navbar/Navbar";

const Header = ({ cartQty }) => {
  return (
    <>
      <LargeContainer bg="#83aa4c">
        <MainContainer halign="space-between">
          <Left>HELLO EVERYONE! 25% OFF ON ALL PRODUCTS</Left>

          <Right>USD | ENGLISH</Right>
        </MainContainer>
      </LargeContainer>
      <Navbar cartQty={cartQty} />
    </>
  );
};
const Left = styled.div`
  padding: 1em;
  cursor: pointer;
  color: white;
  font-size: 14px;
`;
const Right = styled.div`
  display: flex;
  padding: 1em;
  cursor: pointer;
  color: white;
  font-size: 14px;
`;
export default Header;
